"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textStyles = void 0;
const textStyles = theme => ({
  lineHeight: 1.4,
  marginBottom: theme.spacing(1)
});
exports.textStyles = textStyles;